<template>
    <div>
        <StepProgress v-show="currentStep < stepLength" :current-step="currentStep" :step-length="stepLength" />
        <form :key="`step${currentStep + 1}`">
            <slot :name="`step${currentStep + 1}`"></slot>
            <div class="stepper-controls">
                <button v-if="currentStep > 0" class="button is-outlined" type="button" @click="emit('prev')">
                    <slot name="prevBtnLabel">{{ t('prev') }}</slot>
                </button>
                <button v-if="currentStep !== stepLength - 1" class="button" type="button" @click="emit('next')">
                    <slot name="nextBtnLabel">{{ t('next') }}</slot>
                </button>
                <button v-else class="button" type="button" @click="emit('restart')">
                    <slot name="restartBtnLabel">{{ t('newSearch') }}</slot>
                </button>
            </div>
        </form>
    </div>
</template>

<script setup>
import { useI18n } from 'vue-i18n';

import StepProgress from '@/shared/StepProgress';

defineProps({
    currentStep: {
        type: Number,
        default: 0,
    },
    stepLength: {
        type: Number,
        default: 3,
    },
});

const emit = defineEmits(['next', 'prev', 'restart']);

const { t } = useI18n({
    messages: {
        fr: {
            prev: 'Étape précédente',
            next: 'Étape suivante',
            newSearch: 'Nouvelle recherche',
        },
        en: {
            prev: 'Previous step',
            next: 'Next step',
            newSearch: 'New search',
        },
    },
});
</script>

<style lang="scss" scoped>
.stepper-controls {
    display: flex;
    gap: 8px;
    .button {
        @media (max-width: 400px) {
            padding: 12px 14px;
        }
    }
}
</style>
